<template>
    <div id="content">
        <link rel="stylesheet" href="/themes/ito/css/parents.css">

        <div class="container" v-if="!doPlacementTest">
            <div id="page-header-fixed" class="mb-25">
                <div class="container">
                    <div id="page-header">
                        <div class="buttons">
                            <nav-tabs />
                        </div>
                    </div>
                </div>
            </div>
            <div id="upgrade-detail" class="card card-comments">
                <div class="card-body">
                    <h5 class="card-title">
                        <span class="title">{{ title }}</span>
                    </h5>

                    <div class="card-content">
                        <template v-if="packages_list.length > 0">
                            <div v-if="step == 1">
                                <div class="swiper">
                                    <div class="swiper-container" id="scroll-tags">
                                        <div class="swiper-wrapper">
                                            <div class="swiper-slide d-flex">
                                                <div class="collection-list d-flex gap-3">
                                                    <template v-for="(pkg, index) in packages_list">
                                                        <div class="select-upgrade-type mb-20">
                                                            <input :id="'pkg' + index" name="package_select" type="radio" v-model="package_select" :value="pkg.code" />
                                                            <label :for="'pkg' + index" class="package package-1 box-shadow-main">
                                                                <div class="package-title fw-bold">{{ pkg.name }}</div>
                                                                <div class="package-price">{{ pkg.price | toCommas }} {{ $t('vnd_per_month') }}</div>
                                                                <div class="package-content package-content-1">
                                                                    <div v-for="(desc, descIndex) in packages_list[index].desc" :key="descIndex">
                                                                        <img :src="activeIcon" /> {{ desc }}
                                                                    </div>
                                                                </div>
                                                            </label>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="swiper-scrollbar"></div>
                                    </div>
                                </div>
                                <div class="btn-payment box-shadow-main" :class="{ 'disabled': packages_list.length === 0 }"
                                    @click="packages_list.length ? gotoStep(2, package_select) : null"
                                    :aria-disabled="packages_list.length === 0">{{ $t('upgrade_account') }}
                                </div>
                            </div>
                            <div v-if="step == 2">
                                <UpgradeFeatureDetail :package_select="package_select" :products_list="products_list" @updateStep="updateStep" />
                            </div>
                            <div v-if="step == 3">
                                <UpgradeFeaturePayment :package_select="package_select" :showInfo="showInfo" :gates="gates" @updateStep="updateStep" @Payment="Payment" />
                            </div>
                        </template>
                        <template v-else>
                            <p class="text-center p-5">{{ $t('empty_data') }}</p>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { toCommas } from '../../utils/utils'
import { mapGetters } from 'vuex'
import { getFeature, postPayment } from "../../models/payment";
import NavTabs from "../NavTabs.vue";
import activeIcon from '../../../public/themes/ito/images/icons/active-tick.svg';
import UpgradeFeatureDetail from "./UpgradeFeatureDetail.vue";
import UpgradeFeaturePayment from "./UpgradeFeaturePayment.vue";

export default {
    name: "UpgradeFeature",
    title: 'Upgrade Feature',
    components: {
        NavTabs,
        UpgradeFeatureDetail,
        UpgradeFeaturePayment
    },
    data() {
        return {
            activeIcon,
            title: '',
            gates: [],
            products_list: [],
            packages_list: [],
            featureNameMap: {
                'speak_ai_attempt': 'AI Speak PRO',
                'ai_home_tutor': 'AI Tutor PRO'
            },
            featureKeyMap: {
                'speak_ai_attempt': 'ai_speak_pro_package_desc',
                'ai_home_tutor': 'ai_tutor_pro_package_desc'
            },
            featureCodes: ['speak_ai_attempt', 'ai_home_tutor'],
            product: '',
            package_select: 'speak_ai_attempt',
            method: '',
            step: 1
        };
    },

    created() {
        this.title = this.$t('unclock_full_access');
        this.$store.commit('setMenuActive', 'parent');

        const featureCode = this.$route.query.feature_code || null;

        this.fetch().then(() => {
            if (featureCode !== null) {
                this.gotoStep(2, featureCode);
            }
        });
    },

    watch: {
        '$route.query.feature_code'(newFeatureCode) {
            if (newFeatureCode) {
                if (newFeatureCode === 'speak_ai_attempt') {
                    this.title = 'AI Speak PRO';
                }
                else if (newFeatureCode === 'ai_home_tutor') {
                    this.title = 'AI Tutor PRO';
                }
            }
            else {
                this.title = this.$t('unclock_full_access');
                this.gotoStep(1);
            }
        },
        package_select() {
            this.product = '';
            this.method = '';
        },
        product() {
            this.method = '';
        }
    },
    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return this.user
        }),
        doPlacementTest() {
            return this.user_info.placement_test === 0 && this.user_info.student_type !== 1;
        }
    },

    methods: {
        fetch() {
            const that = this;
            that.$store.commit("setLoading", true);

            return axios.all([
                getFeature(),
            ]).then(axios.spread((package_response) => {
                that.$store.commit("setLoading", false);

                if (package_response.data.code != 0) {
                    return;
                }
                that.products_list = package_response.data.results.packages?.[0].products || [];
                that.setupPackages();
                that.gates = package_response.data.results.gate || [];

                if (that.products_list.length > 0) {
                    that.$nextTick(function () {
                        that.initSwiper();
                    });
                }
            }));
        },
        setupPackages() {
            this.products_list.forEach((product) => {
                const existedProduct = this.packages_list.find(p => p.code === product.feature_code);
                if (!existedProduct) {
                    const packageDesc = [];
                    for (let i = 1; i <= 5; i++) {
                        if (this.$te(`${this.featureKeyMap[product.feature_code]}${i}`)) {
                            packageDesc.push(this.$t(`${this.featureKeyMap[product.feature_code]}${i}`));
                        }
                    }
                    this.packages_list.push({
                        code: product.feature_code,
                        name: this.featureNameMap[product.feature_code] || '',
                        price: product.desc.price_month,
                        desc: packageDesc
                    });
                    return;
                }
                if (existedProduct.price > product.desc.price_month) {
                    existedProduct.price = product.desc.price_month;
                }
            });
            this.package_select = this.packages_list.length > 0 ? this.packages_list[0].code : '';
        },
        gotoStep(step, featureCode = null) {
            if (step === 1) {
                if (this.$route.query.feature_code) {
                    this.$router.push({
                        path: `/upgrade-feature`
                    });
                }
            }
            if (step === 2 && featureCode !== null) {
                if (this.featureCodes.find(code => code === featureCode)) {
                    this.package_select = featureCode;
                    if (!this.$route.query.feature_code) {
                        this.$router.push({
                            path: `/upgrade-feature?feature_code=${featureCode}`
                        });
                    }
                }
                else {
                    this.$router.push({
                        path: `/upgrade-feature`
                    });
                    return;
                }
            }
            if (step === 4) {
                this.Payment();
                return;
            }
            this.step = step;
        },
        updateStep(step, product = '', method = '') {
            if (method === '') {
                this.product = product;
            }
            this.method = method;
            this.gotoStep(step);
        },
        showInfo(field) {
            for (const item of this.products_list) {
                if (item.product_id != this.product) {
                    continue;
                }
                if (field === 'name') {
                    return item.product_name;
                }
                if (field === 'price') {
                    // return `${toCommas(item.price)}đ (${toCommas(item.desc.price_month)}đ${this.$t('month')})`;
                    return `${toCommas(item.price)} đ`;
                }
            }
        },
        Payment() {
            const that = this;

            that.$store.commit("setLoading", true);
            const formData = new FormData();
            formData.append('product_id', this.product);
            formData.append('voucher', 'xxx');
            formData.append('method', this.method);
            postPayment(formData).then((data) => {
                that.$store.commit("setLoading", false);
                if (data.data.code == 0) {
                    window.location.href = data.data.results.url;
                } else {
                    alert(data.data.results);
                }
            }).catch(({ response }) => {
                that.$store.commit("setLoading", false);
                console.log('ect', response);
                alert(response.data.results);
            });
        },
        initSwiper() {
            return new Swiper(".swiper-container", {
                slidesPerView: "auto",
                freeMode: true,
                slideToClickedSlide: true,
                spaceBetween: 0,
                scrollbar: {
                    el: ".swiper-scrollbar",
                    draggable: true
                },
                mousewheel: true
            });
        }

    }
}
</script>

<style scoped>
[type="radio"]:not(:checked),
[type="radio"]:checked {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

.package {
    width: 400px !important;
}

.package-content-1 img {
    filter: grayscale(1);
}

.select-upgrade-type [type=radio]:checked+label.package .package-content-1 img {
    filter: grayscale(0);
}

.swiper-container {
    width: 100%;
    height: auto;
}

.swiper-scrollbar-drag {
    background: #C4C4C4;
    border-radius: 10px;
}

.swiper-slide {
    width: auto !important;
}

.btn-payment.disabled {
    opacity: 0.5;
    cursor: not-allowed !important;
}
</style>